import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {
    faClose,
    faEdit,
    faHome,
    faPlus,
    faPrint,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faTrash,
    faTrashAlt,
    faUser,
    faUserCircle,
    faUserPlus,
    faAdd,
    faUserTimes,
    faNetworkWired,
} from "@fortawesome/free-solid-svg-icons";

library.add(faNetworkWired,faEdit, faTrash, faPlus, faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faSearch, faClose, faPrint, faUserCircle, faTrashAlt, faAdd, faUserTimes);

export {FontAwesomeIcon};